import Main from "@/components/main";
import parentView from "@/components/parent-view";

/**
 * iview-admin中meta除了原生参数外可配置的参数:
 * meta: {
 *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项
 *  notCache: (false) 设为true后页面不会缓存
 *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'_'
 *  beforeCloseName: (-) 设置该字段，则在关闭当前tab页时会去'@/router/before-close.js'里寻找该字段名对应的方法，作为关闭前的钩子函数
 * }
 */

export default [
  {
    path: "/login",
    name: "login",
    meta: {
      title: "Login - 登录",
      hideInMenu: true,
    },
    component: () => import("@/views/login/login.vue"),
  },
  {
    path: "/",
    name: "_home",
    redirect: "/home",
    component: Main,
    meta: {
      hideInMenu: false,
      notCache: true,
    },
    children: [
      {
        path: "/home",
        name: "home",
        meta: {
          hideInMenu: false,
          title: "首页",
          notCache: true,
          icon: "md-home",
        },
        component: () => import("@/views/single-page/home"),
      },
    ],
  },
  //项目管理
  {
    path: "/",
    name: "project",
    redirect: "/project",
    component: Main,
    meta: {
      icon: "md-list-box",
      title: "项目",
      access: ["项目经理", "系统管理员"],
    },
    children: [
      {
        path: "/projectManager",
        name: "projectManager",
        meta: {
          hideInMenu: false,
          title: "项目管理",
          notCache: true,
          icon: "md-list",
        },
        component: () => import("@/views/admin/project/projectManager"),
      },
      {
        path: "/projectTypeManager",
        name: "projectTypeManager",
        meta: {
          hideInMenu: false,
          title: "任务类型管理",
          notCache: true,
          icon: "md-list",
        },
        component: () => import("@/views/admin/project/projectTypeManager"),
      },
    ],
  },

  //资源管理
  {
    path: "/",
    name: "resource",
    redirect: "/resource",
    component: Main,
    meta: {
      icon: "ios-book",
      title: "资源",
      access: ["项目经理", "系统管理员", "普通用户"],
    },
    children: [
      {
        path: "/resourceManager",
        name: "resourceManager",
        meta: {
          hideInMenu: false,
          title: "资源管理",
          notCache: true,
          icon: "md-book",
        },
        component: () => import("@/views/admin/resource/resourceManager"),
      },
      {
        path: "/resourceType",
        name: "resourceType",
        meta: {
          hideInMenu: false,
          title: "资源类型",
          notCache: true,
          icon: "md-book",
        },
        component: () => import("@/views/admin/resource/resourceType"),
      },
    ],
  },

  //系统设置
  {
    path: "/",
    name: "admin",
    redirect: "/admin",
    component: Main,
    meta: {
      icon: "md-people",
      title: "系统设置",
      access: ["系统管理员"],
    },
    children: [
      {
        path: "/changePassword",
        name: "changePassword",
        meta: {
          hideInMenu: true,
          title: "修改密码",
          notCache: true,
          icon: "md-home",
        },
        component: () => import("@/views/admin/user/editInfo"),
      },

      {
        path: "/userManager",
        name: "userManager",
        meta: {
          hideInMenu: false,
          title: "用户管理",
          notCache: true,
          icon: "md-people",
        },
        component: () => import("@/views/admin/user/userManager"),
      },

      // {
      //   path: 'error_logger_page',
      //   name: 'error_logger_page',
      //   meta: {
      //     icon: 'ios-bug',
      //     title: '系统日志'
      //   },
      //   component: () => import('@/views/single-page/error-logger.vue')
      // }
    ],
  },
  {
    path: "/401",
    name: "error_401",
    meta: {
      hideInMenu: true,
    },
    component: () => import("@/views/error-page/401.vue"),
  },
  {
    path: "/500",
    name: "error_500",
    meta: {
      hideInMenu: true,
    },
    component: () => import("@/views/error-page/500.vue"),
  },
  {
    path: "*",
    name: "error_404",
    meta: {
      hideInMenu: true,
    },
    component: () => import("@/views/error-page/404.vue"),
  },
];
